const INFO = {
	main: {
		title: "Fadel Razsiah",
		name: "Fadel Razsiah",
		email: "fadelrzsh@gmail.com",
		logo: "../fr.png",
		favicon: "../fr.png",
	},

	socials: {
		github: "https://github.com/fadelrazh",
		linkedin: "https://www.linkedin.com/in/fadel-razsiah",
		instagram: "https://www.instagram.com/fadelrazh/",
	},

	homepage: {
		title: "Hello, I am Fadel Razsiah, but you can call me Dell.",
		description:
			"I'm passionate about creating delightful user experiences through web development. As a software engineer and front-end web developer, I specialize in crafting responsive and interactive web applications that not only meet but exceed user expectations.",
	},

	about: {
		title: "I am Fadel Razsiah, living in Indonesia, shaping the future.",
		description: (
			<>
				I am a recent graduate from Politeknik Manufaktur Negeri Bangka
				Belitung with a degree in Software Engineering. I am very
				enthusiastic about web development, with a strong focus on
				becoming a Frontend Engineer. As a beginner in the field of
				software and web development, I am committed to learning and
				honing my skills while staying updated with the latest industry
				trends. <br />
				<br />
				I'm highly eager to create user experiences that are intuitive
				and visually appealing through web applications and websites. My
				goal is to contribute my expertise to innovative projects and
				collaborate with like-minded individuals. I'm excited to
				continue learning, adapting, and growing in this dynamic field,
				and I welcome opportunities to connect, network, and explore new
				possibilities in the tech industry.
			</>
		),
	},

	projects: [
		{
			title: "Sistem Manajemen Hotel",
			description:
				"I developed the Hotel Management System to streamline hotel operations, including user management, customer handling, POS, and reporting.",
			logo: "../smh.png",
			linkText: "Local Servert",
			link: "http://localhost/simahotel/",
		},

		{
			title: "Anime List",
			description:
				"MyAnimeList is a dynamic website built with the Next.js framework, providing a comprehensive database of anime.",
			logo: "../animelist.png",
			linkText: "View Project",
			link: "https://anime-list-hub.vercel.app",
		},

		{
			title: "Pokemon Dex",
			description:
				"Pokémon Dex is an interactive website built with the Next.js framework, utilizing the PokeAPI (https://pokeapi.co/api/v2/).",
			logo: "../pokemon-dex.png",
			linkText: "View Project",
			link: "https://pokemon-dex-hub.vercel.app",
		},

		{
			title: "Sistem Manajemen Pegawai",
			description:
				"The Employee Management System for Dr. Graphia is a web platform built with Laravel, specifically designed to facilitate employee.",
			logo: "../smp.png",
			linkText: "Local Server",
			link: "http://localhost:8000",
		},

		{
			title: "Sistem Inventory",
			description:
				"Sistem Inventory for PT. Bintang Fajar Mandiri is a robust inventory management website developed using the Codeigniter framework.",
			logo: "../si.png",
			linkText: "Local Server",
			link: "http://localhost/inventory/",
		},

		{
			title: "Satu Data INS",
			description:
				"During my internship at PT. Telkom Indonesia, I worked on Satu Data INS, a digital infrastructure data automation platform by ARMI.",
			logo: "../sdi.png",
			linkText: "No Available",
			link: "https://fadel-razsiah.netlify.app",
		},

		{
			title: "Countdown Timers",
			description:
				"Countdown Timer is a sleek and interactive website built with Next.js, designed to help users set and track countdowns for various events. ",
			logo: "../countdown-timers.png",
			linkText: "View Project",
			link: "https://my-countdown-timers.netlify.app",
		},

		{
			title: "Emoji Search",
			description:
				"React Emoji Search is a responsive and user-friendly website built with React, designed to help users quickly find and explore emojis.",
			logo: "../emoji-search.png",
			linkText: "View Project",
			link: "https://my-emoji-finder.netlify.app/",
		},

		{
			title: "E-Canteen SD Aisyiyah",
			description:
				"Developed using Laravel, the E-Kantin application for SD Aisyiyah Metro Lampung facilitates efficient canteen management.",
			logo: "../e-canteen.png",
			linkText: "Local Server",
			link: "http://localhost:8000",
		},
	],
};

export default INFO;
